<script setup lang="ts">
import { ModeEnum } from '@/types/enums'

const { mode, updateMode } = siteUtils
const route = useRoute()
if (!import.meta.env.SSR) {
  updateMode(ModeEnum.unknown)
}

onMounted(() => {
  watch(() => route.fullPath, () => {
    updateMode(ModeEnum.unknown)
  })
})
</script>

<template>
  <goat-site-main-banner v-if="mode !== ModeEnum.loggedin" />
  <transition
    name="el-fade-in"
    mode="out-in"
  >
    <goat-page-home-logged-box v-if="mode === ModeEnum.loggedin" />
    <div
      v-else
      id="auth-wrapper"
      class="relative"
    >
      <transition
        name="gs-fade-scale"
        mode="out-in"
      >
        <goat-page-home-register-box v-if="mode === ModeEnum.register" />
        <goat-page-home-accept-terms-box v-else-if="mode === ModeEnum.acceptTerms" />
        <goat-page-home-forgot-password-box v-else-if="mode === ModeEnum.forgotPassword" />
        <goat-page-home-reset-password-box v-else-if="mode === ModeEnum.resetPassword" />
        <goat-page-home-confirm-email-box v-else-if="mode === ModeEnum.confirmEmail" />
        <goat-page-home-unsubscribe-box v-else-if="mode === ModeEnum.unsubscribe" />
        <goat-page-home-login-box v-else />
      </transition>
      <goat-site-benefits />
    </div>
  </transition>
</template>

<style scoped>
.box-form-wrapper :deep(.box-form) {
  --el-component-size-large: 44px;
  --el-border-radius-base: 6px;
  --el-border-color: #5a5a5a;

  .el-button {
    --el-button-size: 50px;
  }

  .el-form-item {
    position: relative;

    .el-form-item__label {
      padding-left: 5px;
      position: absolute;
      top: -15px;
      margin:0;
      font-size: 0.6em;
    }
  }

  .el-input__wrapper {
    background-color: #f7f7f7;
  }

  .el-input__count-inner {
    background-color: transparent;
  }

  @media (width >= 900px) {
    --el-component-size-large: 56px;

    .el-button {
      --el-button-size: 54px;
    }

    .el-form-item {
      .el-form-item__label {
        top: -15px;
        font-size: 0.8em;
      }
    }
  }
}
</style>
